import { gql } from '@apollo/client'

import { apolloClient } from './apolloClient'

const getData = (result: { data?: unknown }) =>
  result.data as Record<string, unknown> | undefined

export const smrtArtifactsListQuery = gql`
  query SmrtArtifacts {
    SmrtArtifact_list(first: 200) {
      items {
        id
        smrtVersion
      }
    }
  }
`

export const smrtArtifactByVersionQuery = gql`
  query SmrtArtifactByVersion($smrtVersion: String!) {
    smrtArtifactByVersion(smrtVersion: $smrtVersion) {
      id
      smrtIri
      smrtVersion
      schemaId
      models
      fields
      schema
    }
  }
`

export const getSmrtArtifacts = async () => {
  const result = await apolloClient.query({
    query: smrtArtifactsListQuery,
    fetchPolicy: 'network-only',
  })
  return (getData(result)?.SmrtArtifact_list as any)?.items ?? []
}

export const getSmrtArtifactByVersion = async (smrtVersion: string) => {
  const result = await apolloClient.query({
    query: smrtArtifactByVersionQuery,
    variables: { smrtVersion },
  })
  return getData(result)?.smrtArtifactByVersion ?? null
}
